module.exports = __webpack_public_path__ + "img/6b19523f3ba8242fa1200e7baecadf61.png";